import { Schemas } from '@/openapi/client'

export type PaidFeatureCode = NonNullable<Schemas['PaidFeature']['code']>

type UserWithFeatures = Pick<Schemas['OwnUser'], 'paidFeatures'>

export class FeatureService {
  /**
   * paidFeatures не зависит от подписки: у брендов и инфлюенсеров список
   * непустой и без isPaidSubscriber — часть платных фич им доступна бесплатно.
   */
  static has(user: UserWithFeatures | null | undefined, code: PaidFeatureCode) {
    return Boolean(user?.paidFeatures?.some((feature) => feature.code === code))
  }
}
